// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@300;500;700&family=Geist+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-page {
    --hmi-bg: #F5F8FC;
    --hmi-card: #FFFFFF;
    --hmi-accent: #006AFF;
    --hmi-accent-ink: #FFFFFF;
    --hmi-text: #0F1926;
    --hmi-muted: #596980;
    --hmi-hover: #E8F1FF;
    --hmi-border: #8F9EB3;
    --hmi-shadow: 0 1px 2px rgba(15, 25, 38, 0.04), 0 10px 28px rgba(15, 25, 38, 0.05);
    --hmi-row: #F5F8FC;
    --hmi-good: #047857;
    --hmi-good-bg: #ECFDF5;
    --hmi-warn: #B45309;
    --hmi-warn-bg: #FFFBEB;
    --hmi-danger: #B91C1C;
    --hmi-danger-bg: #FEF2F2;
    --hmi-input: #FFFFFF;
    color-scheme: light;
    box-sizing: border-box;
    min-height: calc(100vh - 64px);
    padding: 28px 32px 40px;
    overflow-x: clip;
    background: var(--hmi-bg);
    color: var(--hmi-text);
    font-family: "Be Vietnam Pro", Arial, sans-serif;
    font-weight: 300;
}

.tag-page[data-theme="dark"] {
    --hmi-bg: #0F1926;
    --hmi-card: #162433;
    --hmi-accent: #006AFF;
    --hmi-accent-ink: #FFFFFF;
    --hmi-text: #FFFFFF;
    --hmi-muted: #8F9EB3;
    --hmi-hover: #1C2C42;
    --hmi-border: #596980;
    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);
    --hmi-row: #0F1926;
    --hmi-good: #34D399;
    --hmi-good-bg: rgba(52, 211, 153, 0.12);
    --hmi-warn: #FBBF24;
    --hmi-warn-bg: rgba(251, 191, 36, 0.12);
    --hmi-danger: #FCA5A5;
    --hmi-danger-bg: rgba(248, 113, 113, 0.12);
    --hmi-input: #0F1926;
    color-scheme: dark;
}

.tag-page *,
.tag-page *::before,
.tag-page *::after {
    box-sizing: border-box;
}

.tag-page h1,
.tag-page h2,
.tag-page h3,
.tag-page button,
.tag-page label,
.tag-page th {
    font-weight: 500;
}

.tag-page h1,
.tag-page h2,
.tag-page p {
    margin: 0;
    color: var(--hmi-text);
}

.tag-page__top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 22px;
}

.tag-page__count {
    display: inline-grid;
    place-items: center;
    min-width: 1.7em;
    height: 1.7em;
    margin-left: 8px;
    padding: 0 6px;
    border-radius: 999px;
    background: var(--hmi-hover);
    color: var(--hmi-text);
    font-size: 12px;
    font-variant-numeric: tabular-nums;
}

.tag-page__eyebrow {
    margin-bottom: 6px;
    color: var(--hmi-accent);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.tag-page h1 {
    font-size: 32px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.03em;
}

.tag-page__subtitle,
.tag-page__card-head p,
.tag-page__hint {
    margin-top: 6px;
    color: var(--hmi-muted);
    font-size: 15px;
    line-height: 1.45;
}

.tag-page__card {
    margin-bottom: 18px;
    border: 1px solid var(--hmi-border);
    border-radius: 18px;
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
    overflow: hidden;
}

.tag-page__card-head {
    padding: 18px 18px 0;
}

.tag-page__card-head--split {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 18px;
    padding-bottom: 14px;
    border-bottom: 1px solid var(--hmi-border);
}

.tag-page__card-head h2 {
    font-size: 18px;
    letter-spacing: -0.02em;
}

.tag-page__card-head p {
    margin-top: 4px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.tag-page__form,
.tag-page__actions,
.tag-page__hint,
.tag-page__banner,
.tag-page__empty {
    margin: 16px 18px;
}

.tag-page__form {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
}

.tag-page__tools {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
}

.tag-page__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 200px;
}

.tag-page__field label {
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tag-page__field input,
.tag-page__field select,
.tag-page__field textarea {
    width: 100%;
    max-width: none;
    height: 40px;
    margin: 0;
    padding: 0 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
    font-size: 14px;
}

.tag-page__field textarea {
    height: auto;
    min-height: 82px;
    padding-top: 10px;
    padding-bottom: 10px;
    resize: vertical;
}

.tag-page__field input:focus-visible,
.tag-page__field select:focus-visible,
.tag-page__field textarea:focus-visible,
.tag-page__button:focus-visible {
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.tag-page__group-management-form {
    display: grid;
    grid-template-columns: minmax(180px, 0.8fr) minmax(180px, 0.8fr) minmax(260px, 1.4fr);
    gap: 14px;
    align-items: end;
    margin: 16px 18px;
}

.tag-page__group-description {
    grid-row: span 2;
}

.tag-page__group-actions {
    grid-column: 1 / -1;
    margin: 0;
}

.tag-page__group-tags {
    grid-column: 1 / -1;
    min-width: 0;
    margin: 0;
    padding: 14px;
    border: 1px solid var(--hmi-border);
    border-radius: 12px;
    background: var(--hmi-row);
}

.tag-page__group-tags legend {
    padding: 0 6px;
    color: var(--hmi-text);
    font-weight: 700;
}

.tag-page__group-tags-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.tag-page__group-tags-head p {
    color: var(--hmi-muted);
    font-size: 13px;
    line-height: 1.45;
}

.tag-page__group-tag-filters {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(140px, 0.7fr) minmax(140px, 0.7fr);
    gap: 8px;
    width: min(640px, 100%);
}

.tag-page__group-tag-filters input,
.tag-page__group-tag-filters select {
    width: 100%;
    height: 38px;
    padding: 0 10px;
    border: 1px solid var(--hmi-border);
    border-radius: 9px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
}

.tag-page__group-tag-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    max-height: 320px;
    overflow-y: auto;
}

.tag-page__group-tag-option {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    min-width: 0;
    padding: 10px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-card);
    color: var(--hmi-text);
    cursor: pointer;
}

.tag-page__group-tag-option input {
    flex: 0 0 auto;
    margin-top: 3px;
}

.tag-page__group-tag-option span {
    display: grid;
    min-width: 0;
    gap: 3px;
}

.tag-page__group-tag-option strong,
.tag-page__group-tag-option small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tag-page__group-tag-option small {
    color: var(--hmi-muted);
    font-size: 11px;
}

.tag-page__group-row-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tag-page__group-row-actions .tag-page__button {
    min-height: 34px;
    padding: 6px 10px;
    font-size: 12px;
}

.tag-page__hint {
    margin-top: 0;
    font-size: 13px;
}

.tag-page__hint strong {
    color: var(--hmi-text);
    font-weight: 700;
}

.tag-page__presets {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.tag-page__preset {
    min-height: 32px;
    margin: 0;
    padding: 4px 10px;
    border: 1px solid var(--hmi-border);
    border-radius: 8px;
    background: var(--hmi-card);
    color: var(--hmi-text);
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
}

.tag-page__preset.is-selected {
    border-color: var(--hmi-accent);
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.tag-page__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.tag-page__button {
    min-height: 40px;
    margin: 0;
    padding: 10px 16px;
    border: 1px solid var(--hmi-accent);
    border-radius: 12px;
    background: var(--hmi-card);
    color: var(--hmi-accent);
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: var(--hmi-shadow);
}

.tag-page__button--primary {
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.tag-page__button:hover:not(:disabled),
.tag-page__button:focus-visible:not(:disabled) {
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.tag-page__button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.tag-page__button--danger {
    border-color: var(--hmi-danger);
    background: var(--hmi-danger-bg);
    color: var(--hmi-danger);
}

.tag-page__banner {
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid var(--hmi-border);
    background: var(--hmi-row);
    color: var(--hmi-text);
    font-size: 14px;
    font-weight: 600;
}

.tag-page__banner.is-success {
    color: var(--hmi-good);
    background: var(--hmi-good-bg);
    border-color: transparent;
}

.tag-page__banner.is-error {
    color: var(--hmi-danger);
    background: var(--hmi-danger-bg);
    border-color: transparent;
}

.tag-page__banner.is-pending {
    color: var(--hmi-warn);
    background: var(--hmi-warn-bg);
    border-color: transparent;
}

.tag-page__empty {
    padding: 28px 0 32px;
    color: var(--hmi-muted);
    text-align: center;
    font-size: 14px;
}

.tag-page__table-wrap {
    width: 100%;
    overflow-x: auto;
}

.tag-page__table {
    width: 100%;
    min-width: 720px;
    border-collapse: collapse;
}

.tag-page__table th,
.tag-page__table td {
    padding: 13px 16px;
    border-bottom: 1px solid var(--hmi-border);
    color: var(--hmi-text);
    text-align: left;
    vertical-align: middle;
    font-size: 14px;
}

.tag-page__table th {
    background: var(--hmi-row);
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
}

.tag-page__table tbody tr:last-child td {
    border-bottom: 0;
}

.tag-page__table tbody tr:hover td {
    background: var(--hmi-hover);
}

.tag-page__strong {
    font-weight: 600;
}

.tag-page__mono {
    font-variant-numeric: tabular-nums;
    font-family: "Geist Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 13px;
}

.tag-page__server-name {
    display: inline-block;
    margin-left: 8px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.tag-page h3,
.tag-page h4 {
    margin: 0;
    color: var(--hmi-text);
}

.tag-page__browser {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(280px, 0.9fr);
    gap: 16px;
    margin: 16px 18px;
    align-items: stretch;
}

.tag-page__tree-pane,
.tag-page__details {
    min-width: 0;
    border: 1px solid var(--hmi-border);
    border-radius: 14px;
    background: var(--hmi-row);
}

.tag-page__tree-pane {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.tag-page__tree-pane h3,
.tag-page__details h3 {
    padding: 14px 14px 0;
    font-size: 14px;
    letter-spacing: -0.01em;
}

.tag-page__tree {
    list-style: none;
    flex: 1 1 auto;
    max-height: none;
    min-height: 240px;
    margin: 0;
    padding: 10px 8px 12px;
    overflow: auto;
}

.tag-page__tree .tag-page__tree {
    max-height: none;
    padding: 0;
    overflow: visible;
}

.tag-page__tree-item {
    margin: 0;
}

.tag-page__tree-row {
    display: flex;
    align-items: center;
    gap: 4px;
    padding-left: calc(var(--tree-depth, 0) * 16px);
}

.tag-page__tree-toggle,
.tag-page__tree-label {
    margin: 0;
    border: 0;
    background: transparent;
    color: var(--hmi-text);
    font: inherit;
    cursor: pointer;
}

.tag-page__tree-toggle {
    width: 28px;
    height: 32px;
    flex: 0 0 28px;
    border-radius: 8px;
    color: var(--hmi-muted);
    font-size: 12px;
}

.tag-page__tree-label {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    min-width: 0;
    min-height: 32px;
    padding: 4px 8px;
    border-radius: 8px;
    text-align: left;
}

.tag-page__tree-label span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tag-page__tree-type {
    flex: 0 0 auto;
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.tag-page__tree-toggle:hover,
.tag-page__tree-toggle:focus-visible,
.tag-page__tree-label:hover,
.tag-page__tree-label:focus-visible,
.tag-page__tree-label.is-selected {
    background: var(--hmi-hover);
    outline: none;
}

.tag-page__tree-label.is-selected,
.tag-page__table tbody tr.is-selected td {
    background: var(--hmi-hover);
    color: var(--hmi-accent);
}

.tag-page__tree-label:focus-visible,
.tag-page__tree-toggle:focus-visible,
.tag-page__row-select:focus-visible {
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.tag-page__details {
    padding: 0 14px 14px;
}

.tag-page__facts {
    display: grid;
    gap: 10px;
    margin: 12px 0;
}

.tag-page__facts div {
    display: grid;
    gap: 2px;
}

.tag-page__facts dt {
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tag-page__facts dd {
    margin: 0;
    color: var(--hmi-text);
    font-size: 14px;
    overflow-wrap: anywhere;
}

.tag-page__register {
    display: grid;
    gap: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--hmi-border);
}

.tag-page__register p {
    color: var(--hmi-muted);
    font-size: 13px;
    line-height: 1.45;
}

.tag-page__register h4 {
    font-size: 15px;
}

.tag-page__field input[readonly] {
    background: var(--hmi-row);
    color: var(--hmi-muted);
}

.tag-page__details .tag-page__empty {
    padding: 24px 0;
}

.tag-page__row-select {
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
}

.tag-page__row-select:hover,
.tag-page__row-select:focus-visible {
    color: var(--hmi-accent);
}

.tag-page__top > .tag-page__button {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
}

.tag-page__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 10px;
    margin: 16px 18px 0;
}

.tag-page__toolbar .tag-page__field {
    min-width: 180px;
    flex: 1 1 180px;
}

.tag-page__field--search {
    flex: 1.4 1 240px;
}

.tag-page__copy-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.tag-page__copy-row input {
    flex: 1 1;
    min-width: 0;
}

.tag-page__register .tag-page__banner {
    margin: 0;
}

.tag-page__workspace {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 10px var(--tag-panel-width, 380px);
    align-items: start;
    gap: 0;
}

.tag-page__workspace.is-collapsed {
    grid-template-columns: minmax(0, 1fr);
}

.tag-page__tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
}

.tag-page__tabs button {
    min-height: 44px;
    padding: 10px 18px;
    border: 1px solid var(--hmi-border);
    border-radius: 12px;
    background: var(--hmi-card);
    color: var(--hmi-text);
    font: inherit;
    font-weight: 500;
    cursor: pointer;
}

.tag-page__tabs button[aria-selected="true"] {
    border-color: var(--hmi-accent);
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.tag-page__registry-tools {
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(180px, 0.6fr);
    gap: 14px;
    margin: 16px 18px;
}

.tag-page__registry-tools .tag-page__field {
    min-width: 0;
    margin: 0;
}

.tag-page__registry-scroll {
    width: 100%;
    margin: 0;
}

.tag-page__registry-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.tag-page__registry-table th,
.tag-page__registry-table td {
    padding: 12px 14px;
    border-bottom: 1px solid var(--hmi-border);
    color: var(--hmi-text);
    text-align: left;
    vertical-align: middle;
    overflow-wrap: anywhere;
    font-size: 14px;
}

.tag-page__registry-table th {
    background: var(--hmi-row);
    color: var(--hmi-muted);
    font-size: 11px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tag-page__registry-table tbody tr.is-selected td {
    background: var(--hmi-hover);
}

.tag-page__manage {
    scroll-margin-top: 80px;
}

.tag-page__sr {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.tag-page__divider {
    align-self: stretch;
    width: 10px;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: col-resize;
    touch-action: none;
}

.tag-page__divider::before {
    content: "";
    display: block;
    width: 2px;
    height: 100%;
    min-height: 240px;
    margin: 0 auto;
    border-radius: 2px;
    background: var(--hmi-border);
}

.tag-page__divider:focus-visible {
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.tag-page__panel {
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 420px;
    max-height: calc(100vh - 96px);
    position: sticky;
    top: 76px;
    border: 1px solid var(--hmi-border);
    border-radius: 18px;
    background: var(--hmi-card);
    color: var(--hmi-text);
    box-shadow: var(--hmi-shadow);
    overflow: hidden;
}

.tag-page__panel[hidden] {
    display: none;
}

.tag-page__panel-head {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    border-bottom: 1px solid var(--hmi-border);
}

.tag-page__panel-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
}

.tag-page__panel-head h2 {
    font-size: 18px;
    letter-spacing: -0.02em;
}

.tag-page__panel-head p {
    margin-top: 4px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.tag-page__panel-tools {
    display: grid;
    gap: 10px;
    padding: 16px;
    border-bottom: 1px solid var(--hmi-border);
}

.tag-page__panel-tools .tag-page__field {
    min-width: 0;
    margin: 0;
}

.tag-page__panel .tag-page__banner {
    margin: 12px 16px 0;
}

.tag-page__panel-body {
    flex: 1 1;
    min-height: 120px;
    overflow: auto;
}

.tag-page__tag-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.tag-page__tag-item {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    align-items: center;
    padding: 8px 12px 8px 0;
    border-bottom: 1px solid var(--hmi-border);
}

.tag-page__tag-item.is-selected {
    background: var(--hmi-hover);
}

.tag-page__tag-edit {
    min-height: 32px;
    padding: 6px 10px;
}

.tag-page__tag-row {
    display: grid;
    gap: 4px;
    width: 100%;
    min-width: 0;
    padding: 10px 16px;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
}

.tag-page__tag-row:hover,
.tag-page__tag-row:focus-visible {
    background: var(--hmi-hover);
}

.tag-page__tag-item.is-selected .tag-page__strong {
    color: var(--hmi-accent);
}

.tag-page__tag-row .tag-page__mono {
    overflow-wrap: anywhere;
}

.tag-page__tag-server {
    display: flex;
    gap: 8px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.tag-page__manage {
    min-width: 0;
    max-width: 100%;
}

.tag-page__manage-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 18px 18px 14px;
    border-bottom: 1px solid var(--hmi-border);
}

.tag-page__manage-head h2 {
    font-size: 18px;
    letter-spacing: -0.02em;
}

.tag-page__manage-head p {
    margin-top: 4px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.tag-page__editor-close {
    display: inline-grid;
    place-items: center;
    width: 40px;
    height: 40px;
    flex: 0 0 auto;
    padding: 0;
    border: 1px solid var(--hmi-border);
    border-radius: 12px;
    background: var(--hmi-card);
    color: var(--hmi-text);
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
}

.tag-page__editor-close:hover,
.tag-page__editor-close:focus-visible {
    border-color: var(--hmi-accent);
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.tag-page__identity {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 18px;
    margin: 0;
    padding: 16px 18px;
    border-bottom: 1px solid var(--hmi-border);
}

.tag-page__identity dt {
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tag-page__identity dd {
    margin: 4px 0 0;
    overflow-wrap: anywhere;
}

.tag-page__editor-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin: 16px 18px;
}

.tag-page__editor textarea {
    width: 100%;
    min-height: 72px;
    padding: 8px 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
}

.tag-page__editor-span {
    grid-column: 1 / -1;
}

.tag-page__group {
    display: grid;
    align-content: start;
    gap: 12px;
    min-width: 0;
    padding: 14px;
    border: 1px solid var(--hmi-border);
    border-radius: 14px;
    background: var(--hmi-row);
}

.tag-page__group h3 {
    margin: 0;
    font-size: 15px;
}

.tag-page__group .tag-page__actions {
    align-items: flex-end;
}

.tag-page__group .tag-page__actions .tag-page__field {
    flex: 1 1 180px;
}

.tag-page__manage .tag-page__field,
.tag-page__manage .tag-page__hint,
.tag-page__manage .tag-page__banner,
.tag-page__manage .tag-page__actions {
    min-width: 0;
    margin: 0;
}

.tag-page__manage .tag-page__editor-actions,
.tag-page__manage .tag-page__banner,
.tag-page__editor > .tag-page__hint,
.tag-page__manage > .tag-page__hint {
    margin: 0 18px 12px;
}

.tag-page__editor-actions {
    padding-bottom: 6px;
}

.tag-page__status {
    display: inline-flex;
    width: fit-content;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
}

.tag-page__status--ONLINE {
    color: var(--hmi-good);
    background: var(--hmi-good-bg);
}

.tag-page__status--OFFLINE {
    color: var(--hmi-danger);
    background: var(--hmi-danger-bg);
}

.tag-page__status--UNKNOWN {
    color: var(--hmi-warn);
    background: var(--hmi-warn-bg);
}

.tag-page__archived {
    display: grid;
    gap: 12px;
    margin: 0 18px 18px;
    padding-top: 14px;
    border-top: 1px solid var(--hmi-border);
}

.tag-page__archived-head,
.tag-page__archived-list li {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.tag-page__archived h3,
.tag-page__archived-list {
    margin: 0;
}

.tag-page__archived-list {
    display: grid;
    gap: 8px;
    padding: 0;
    list-style: none;
}

.tag-page__stored {
    display: grid;
    gap: 10px;
    padding: 14px 16px 16px;
    border-top: 1px solid var(--hmi-border);
}

.tag-page__stored h3 {
    margin: 0;
    font-size: 15px;
}

.tag-page__stored .tag-page__empty,
.tag-page__stored .tag-page__hint,
.tag-page__stored .tag-page__actions {
    margin: 0;
}

.tag-page__stored .tag-page__empty {
    padding: 0;
}

.tag-page__stored .tag-page__button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

@media (max-width: 980px) {
    .tag-page__form,
    .tag-page__group-management-form,
    .tag-page__card-head--split {
        grid-template-columns: 1fr;
        flex-direction: column;
        align-items: stretch;
    }

    .tag-page__tools {
        justify-content: flex-start;
    }

    .tag-page__browser,
    .tag-page__editor-grid,
    .tag-page__identity {
        grid-template-columns: 1fr;
    }

    .tag-page__editor-span {
        grid-column: auto;
    }

    .tag-page__group-description,
    .tag-page__group-actions {
        grid-column: auto;
        grid-row: auto;
    }

    .tag-page__group-tags-head {
        align-items: stretch;
        flex-direction: column;
    }

    .tag-page__group-tag-filters {
        grid-template-columns: 1fr;
        width: 100%;
    }

    .tag-page__group-tag-list {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 800px) {
    .tag-page__workspace,
    .tag-page__workspace.is-collapsed {
        grid-template-columns: minmax(0, 1fr);
    }

    .tag-page__tabs {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        margin-bottom: 12px;
    }

    .tag-page__tabs button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        min-height: 40px;
        padding: 8px 12px;
        border: 1px solid var(--hmi-border);
        border-radius: 12px;
        background: var(--hmi-card);
        color: var(--hmi-text);
        font: inherit;
        font-weight: 650;
        cursor: pointer;
    }

    .tag-page__tabs button[aria-selected="true"] {
        border-color: var(--hmi-accent);
        background: var(--hmi-accent);
        color: var(--hmi-accent-ink);
    }

    .tag-page__divider {
        display: none;
    }

    .tag-page__panel {
        position: static;
        max-height: none;
        min-height: 0;
    }

    .tag-page__panel-body {
        max-height: 50vh;
    }

    .tag-page {
        padding: 18px 14px 28px;
    }

    .tag-page h1 {
        font-size: 26px;
    }

    .tag-page__top,
    .tag-page__copy-row {
        flex-direction: column;
        align-items: stretch;
    }

    .tag-page__actions .tag-page__button,
    .tag-page__register > .tag-page__button {
        width: 100%;
    }

    .tag-page__registry-tools,
    .tag-page__editor-grid,
    .tag-page__identity {
        grid-template-columns: 1fr;
    }

    .tag-page__registry-table thead {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
    }

    .tag-page__registry-table,
    .tag-page__registry-table tbody,
    .tag-page__registry-table tr,
    .tag-page__registry-table td {
        display: block;
        width: 100%;
    }

    .tag-page__registry-table tr {
        padding: 8px 0 12px;
        border-bottom: 1px solid var(--hmi-border);
    }

    .tag-page__registry-table td {
        border-bottom: 0;
        padding: 6px 16px;
    }

    .tag-page__registry-table td::before {
        content: attr(data-label);
        display: block;
        margin-bottom: 2px;
        color: var(--hmi-muted);
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 0.05em;
        text-transform: uppercase;
    }
}

@media (prefers-reduced-motion: reduce) {
    .tag-page__button,
    .tag-page__table td {
        transition: none;
    }
}

.tag-page__metadata section + section {
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid var(--hmi-border);
}

.tag-page__metadata h4,
.tag-page__suggestion h4 {
    margin: 0 0 6px;
    color: var(--hmi-text);
    font-size: 13px;
}

.tag-page__meta-source,
.tag-page__metadata p,
.tag-page__suggestion p {
    margin: 0 0 8px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.tag-page__metadata .tag-page__facts dd,
.tag-page__suggestion .tag-page__facts dd {
    font-family: "Geist Mono", ui-monospace, monospace;
    overflow-wrap: anywhere;
}

.tag-page__quality.is-good {
    color: var(--hmi-good);
}

.tag-page__quality.is-bad {
    color: var(--hmi-danger);
}

.tag-page__quality.is-uncertain {
    color: var(--hmi-warn);
}

.tag-page__suggestion {
    margin-top: 16px;
    padding: 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 12px;
    background: var(--hmi-row);
}

.tag-page__suggestion ul {
    margin: 8px 0 0;
    padding-left: 18px;
    color: var(--hmi-text);
}

.tag-page__review {
    display: grid;
    gap: 10px;
    margin: 16px 0;
    padding: 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 12px;
    background: var(--hmi-row);
}

.tag-page__review legend {
    padding: 0 4px;
    color: var(--hmi-text);
    font-weight: 500;
}

.tag-page__check {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    color: var(--hmi-text);
}

.tag-page__section {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px 16px;
    margin: 0;
    padding: 4px 0 8px;
    border-top: 1px solid var(--hmi-border);
}

.tag-page__section h3 {
    margin: 0;
    color: var(--hmi-muted);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.tag-page__create {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px 16px;
    margin: 16px 18px;
}

.tag-page__create--embedded {
    margin: 12px 0 0;
    padding-top: 12px;
    border-top: 1px solid var(--hmi-border);
}

.tag-page__create .tag-page__field--wide,
.tag-page__create .tag-page__actions,
.tag-page__create .tag-page__hint,
.tag-page__create .tag-page__banner {
    grid-column: 1 / -1;
    margin: 0;
}

.tag-page__create textarea {
    width: 100%;
    min-height: 72px;
    padding: 8px 10px;
    border: 1px solid var(--hmi-border);
    border-radius: 8px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
}

.tag-page__required {
    color: var(--hmi-danger);
    font-size: 12px;
}

.tag-page__field-error {
    margin: 4px 0 0;
    color: var(--hmi-danger);
    font-size: 12px;
}

@media (min-width: 760px) {
    .tag-page__create {
        grid-template-columns: 1fr;
    }

    .tag-page__section {
        grid-template-columns: 1fr 1fr;
    }

    .tag-page__section h3,
    .tag-page__section .tag-page__field--wide,
    .tag-page__section .tag-page__hint,
    .tag-page__section .tag-page__banner {
        grid-column: 1 / -1;
    }
}

.tag-page__check {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
}

.tag-page__lifecycle {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border: 1px solid var(--hmi-border);
    border-radius: 999px;
    color: var(--hmi-muted);
    font-size: 12px;
    letter-spacing: 0.04em;
}

.tag-page__lifecycle--ACTIVE {
    color: var(--hmi-text);
    border-color: var(--hmi-text);
}

.tag-page__occupants {
    margin: 0;
    padding-left: 18px;
    color: var(--hmi-muted);
}

.tag-page__dialog {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid var(--hmi-danger);
    border-radius: 12px;
    background: var(--hmi-card);
}

.tag-page__dialog h3 {
    margin: 0 0 8px;
    font-weight: 500;
}

.tag-page__archived-page {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    margin: 0 18px 18px;
}

.tag-page__archived-detail {
    width: 100%;
    margin: 0;
}

.tag-page__archived-detail .tag-page__identity {
    margin: 0 18px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AddTag.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,kFAAkF;IAClF,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,4EAA4E;IAC5E,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,uCAAuC;IACvC,qBAAqB;IACrB,0CAA0C;IAC1C,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,gBAAgB;AACpB;;AAEA;;;IAGI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,4BAA4B;IAC5B,sBAAsB;IACtB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;IAGI,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;;;;IAKI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;;;IAII,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qFAAqF;IACrF,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mFAAmF;IACnF,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,QAAQ;AACZ;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,mFAAmF;IACnF,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;IACpB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,+CAA+C;AACnD;;AAEA;;IAEI,SAAS;IACT,SAAS;IACT,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;;;;IAKI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;;IAEI,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;;;IAGI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,wEAAwE;IACxE,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,+BAA+B;IAC/B,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;IAII,YAAY;IACZ,SAAS;AACb;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;;;QAGI,0BAA0B;QAC1B,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;;QAEI,qCAAqC;IACzC;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;QACR,gBAAgB;QAChB,iBAAiB;QACjB,mCAAmC;QACnC,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,aAAa;QACb,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,+BAA+B;QAC/B,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;;;;QAII,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,kBAAkB;QAClB,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;;IAEI,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;;IAGI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,kDAAkD;IAClD,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;;;;IAII,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;;;QAII,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@300;500;700&family=Geist+Mono:wght@400;500&display=swap\");\n\n.tag-page {\n    --hmi-bg: #F5F8FC;\n    --hmi-card: #FFFFFF;\n    --hmi-accent: #006AFF;\n    --hmi-accent-ink: #FFFFFF;\n    --hmi-text: #0F1926;\n    --hmi-muted: #596980;\n    --hmi-hover: #E8F1FF;\n    --hmi-border: #8F9EB3;\n    --hmi-shadow: 0 1px 2px rgba(15, 25, 38, 0.04), 0 10px 28px rgba(15, 25, 38, 0.05);\n    --hmi-row: #F5F8FC;\n    --hmi-good: #047857;\n    --hmi-good-bg: #ECFDF5;\n    --hmi-warn: #B45309;\n    --hmi-warn-bg: #FFFBEB;\n    --hmi-danger: #B91C1C;\n    --hmi-danger-bg: #FEF2F2;\n    --hmi-input: #FFFFFF;\n    color-scheme: light;\n    box-sizing: border-box;\n    min-height: calc(100vh - 64px);\n    padding: 28px 32px 40px;\n    overflow-x: clip;\n    background: var(--hmi-bg);\n    color: var(--hmi-text);\n    font-family: \"Be Vietnam Pro\", Arial, sans-serif;\n    font-weight: 300;\n}\n\n.tag-page[data-theme=\"dark\"] {\n    --hmi-bg: #0F1926;\n    --hmi-card: #162433;\n    --hmi-accent: #006AFF;\n    --hmi-accent-ink: #FFFFFF;\n    --hmi-text: #FFFFFF;\n    --hmi-muted: #8F9EB3;\n    --hmi-hover: #1C2C42;\n    --hmi-border: #596980;\n    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);\n    --hmi-row: #0F1926;\n    --hmi-good: #34D399;\n    --hmi-good-bg: rgba(52, 211, 153, 0.12);\n    --hmi-warn: #FBBF24;\n    --hmi-warn-bg: rgba(251, 191, 36, 0.12);\n    --hmi-danger: #FCA5A5;\n    --hmi-danger-bg: rgba(248, 113, 113, 0.12);\n    --hmi-input: #0F1926;\n    color-scheme: dark;\n}\n\n.tag-page *,\n.tag-page *::before,\n.tag-page *::after {\n    box-sizing: border-box;\n}\n\n.tag-page h1,\n.tag-page h2,\n.tag-page h3,\n.tag-page button,\n.tag-page label,\n.tag-page th {\n    font-weight: 500;\n}\n\n.tag-page h1,\n.tag-page h2,\n.tag-page p {\n    margin: 0;\n    color: var(--hmi-text);\n}\n\n.tag-page__top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 22px;\n}\n\n.tag-page__count {\n    display: inline-grid;\n    place-items: center;\n    min-width: 1.7em;\n    height: 1.7em;\n    margin-left: 8px;\n    padding: 0 6px;\n    border-radius: 999px;\n    background: var(--hmi-hover);\n    color: var(--hmi-text);\n    font-size: 12px;\n    font-variant-numeric: tabular-nums;\n}\n\n.tag-page__eyebrow {\n    margin-bottom: 6px;\n    color: var(--hmi-accent);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.tag-page h1 {\n    font-size: 32px;\n    line-height: 1.15;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n}\n\n.tag-page__subtitle,\n.tag-page__card-head p,\n.tag-page__hint {\n    margin-top: 6px;\n    color: var(--hmi-muted);\n    font-size: 15px;\n    line-height: 1.45;\n}\n\n.tag-page__card {\n    margin-bottom: 18px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 18px;\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n    overflow: hidden;\n}\n\n.tag-page__card-head {\n    padding: 18px 18px 0;\n}\n\n.tag-page__card-head--split {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 18px;\n    padding-bottom: 14px;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.tag-page__card-head h2 {\n    font-size: 18px;\n    letter-spacing: -0.02em;\n}\n\n.tag-page__card-head p {\n    margin-top: 4px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.tag-page__form,\n.tag-page__actions,\n.tag-page__hint,\n.tag-page__banner,\n.tag-page__empty {\n    margin: 16px 18px;\n}\n\n.tag-page__form {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 14px;\n}\n\n.tag-page__tools {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.tag-page__field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 200px;\n}\n\n.tag-page__field label {\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.tag-page__field input,\n.tag-page__field select,\n.tag-page__field textarea {\n    width: 100%;\n    max-width: none;\n    height: 40px;\n    margin: 0;\n    padding: 0 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 14px;\n}\n\n.tag-page__field textarea {\n    height: auto;\n    min-height: 82px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    resize: vertical;\n}\n\n.tag-page__field input:focus-visible,\n.tag-page__field select:focus-visible,\n.tag-page__field textarea:focus-visible,\n.tag-page__button:focus-visible {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.tag-page__group-management-form {\n    display: grid;\n    grid-template-columns: minmax(180px, 0.8fr) minmax(180px, 0.8fr) minmax(260px, 1.4fr);\n    gap: 14px;\n    align-items: end;\n    margin: 16px 18px;\n}\n\n.tag-page__group-description {\n    grid-row: span 2;\n}\n\n.tag-page__group-actions {\n    grid-column: 1 / -1;\n    margin: 0;\n}\n\n.tag-page__group-tags {\n    grid-column: 1 / -1;\n    min-width: 0;\n    margin: 0;\n    padding: 14px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 12px;\n    background: var(--hmi-row);\n}\n\n.tag-page__group-tags legend {\n    padding: 0 6px;\n    color: var(--hmi-text);\n    font-weight: 700;\n}\n\n.tag-page__group-tags-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.tag-page__group-tags-head p {\n    color: var(--hmi-muted);\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n.tag-page__group-tag-filters {\n    display: grid;\n    grid-template-columns: minmax(180px, 1fr) minmax(140px, 0.7fr) minmax(140px, 0.7fr);\n    gap: 8px;\n    width: min(640px, 100%);\n}\n\n.tag-page__group-tag-filters input,\n.tag-page__group-tag-filters select {\n    width: 100%;\n    height: 38px;\n    padding: 0 10px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 9px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n}\n\n.tag-page__group-tag-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n.tag-page__group-tag-option {\n    display: flex;\n    align-items: flex-start;\n    gap: 9px;\n    min-width: 0;\n    padding: 10px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-card);\n    color: var(--hmi-text);\n    cursor: pointer;\n}\n\n.tag-page__group-tag-option input {\n    flex: 0 0 auto;\n    margin-top: 3px;\n}\n\n.tag-page__group-tag-option span {\n    display: grid;\n    min-width: 0;\n    gap: 3px;\n}\n\n.tag-page__group-tag-option strong,\n.tag-page__group-tag-option small {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.tag-page__group-tag-option small {\n    color: var(--hmi-muted);\n    font-size: 11px;\n}\n\n.tag-page__group-row-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.tag-page__group-row-actions .tag-page__button {\n    min-height: 34px;\n    padding: 6px 10px;\n    font-size: 12px;\n}\n\n.tag-page__hint {\n    margin-top: 0;\n    font-size: 13px;\n}\n\n.tag-page__hint strong {\n    color: var(--hmi-text);\n    font-weight: 700;\n}\n\n.tag-page__presets {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 8px;\n}\n\n.tag-page__preset {\n    min-height: 32px;\n    margin: 0;\n    padding: 4px 10px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 8px;\n    background: var(--hmi-card);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.tag-page__preset.is-selected {\n    border-color: var(--hmi-accent);\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.tag-page__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.tag-page__button {\n    min-height: 40px;\n    margin: 0;\n    padding: 10px 16px;\n    border: 1px solid var(--hmi-accent);\n    border-radius: 12px;\n    background: var(--hmi-card);\n    color: var(--hmi-accent);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: var(--hmi-shadow);\n}\n\n.tag-page__button--primary {\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.tag-page__button:hover:not(:disabled),\n.tag-page__button:focus-visible:not(:disabled) {\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.tag-page__button:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.tag-page__button--danger {\n    border-color: var(--hmi-danger);\n    background: var(--hmi-danger-bg);\n    color: var(--hmi-danger);\n}\n\n.tag-page__banner {\n    padding: 12px 14px;\n    border-radius: 12px;\n    border: 1px solid var(--hmi-border);\n    background: var(--hmi-row);\n    color: var(--hmi-text);\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.tag-page__banner.is-success {\n    color: var(--hmi-good);\n    background: var(--hmi-good-bg);\n    border-color: transparent;\n}\n\n.tag-page__banner.is-error {\n    color: var(--hmi-danger);\n    background: var(--hmi-danger-bg);\n    border-color: transparent;\n}\n\n.tag-page__banner.is-pending {\n    color: var(--hmi-warn);\n    background: var(--hmi-warn-bg);\n    border-color: transparent;\n}\n\n.tag-page__empty {\n    padding: 28px 0 32px;\n    color: var(--hmi-muted);\n    text-align: center;\n    font-size: 14px;\n}\n\n.tag-page__table-wrap {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.tag-page__table {\n    width: 100%;\n    min-width: 720px;\n    border-collapse: collapse;\n}\n\n.tag-page__table th,\n.tag-page__table td {\n    padding: 13px 16px;\n    border-bottom: 1px solid var(--hmi-border);\n    color: var(--hmi-text);\n    text-align: left;\n    vertical-align: middle;\n    font-size: 14px;\n}\n\n.tag-page__table th {\n    background: var(--hmi-row);\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n.tag-page__table tbody tr:last-child td {\n    border-bottom: 0;\n}\n\n.tag-page__table tbody tr:hover td {\n    background: var(--hmi-hover);\n}\n\n.tag-page__strong {\n    font-weight: 600;\n}\n\n.tag-page__mono {\n    font-variant-numeric: tabular-nums;\n    font-family: \"Geist Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    font-size: 13px;\n}\n\n.tag-page__server-name {\n    display: inline-block;\n    margin-left: 8px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.tag-page h3,\n.tag-page h4 {\n    margin: 0;\n    color: var(--hmi-text);\n}\n\n.tag-page__browser {\n    display: grid;\n    grid-template-columns: minmax(0, 1.1fr) minmax(280px, 0.9fr);\n    gap: 16px;\n    margin: 16px 18px;\n    align-items: stretch;\n}\n\n.tag-page__tree-pane,\n.tag-page__details {\n    min-width: 0;\n    border: 1px solid var(--hmi-border);\n    border-radius: 14px;\n    background: var(--hmi-row);\n}\n\n.tag-page__tree-pane {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.tag-page__tree-pane h3,\n.tag-page__details h3 {\n    padding: 14px 14px 0;\n    font-size: 14px;\n    letter-spacing: -0.01em;\n}\n\n.tag-page__tree {\n    list-style: none;\n    flex: 1 1 auto;\n    max-height: none;\n    min-height: 240px;\n    margin: 0;\n    padding: 10px 8px 12px;\n    overflow: auto;\n}\n\n.tag-page__tree .tag-page__tree {\n    max-height: none;\n    padding: 0;\n    overflow: visible;\n}\n\n.tag-page__tree-item {\n    margin: 0;\n}\n\n.tag-page__tree-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding-left: calc(var(--tree-depth, 0) * 16px);\n}\n\n.tag-page__tree-toggle,\n.tag-page__tree-label {\n    margin: 0;\n    border: 0;\n    background: transparent;\n    color: var(--hmi-text);\n    font: inherit;\n    cursor: pointer;\n}\n\n.tag-page__tree-toggle {\n    width: 28px;\n    height: 32px;\n    flex: 0 0 28px;\n    border-radius: 8px;\n    color: var(--hmi-muted);\n    font-size: 12px;\n}\n\n.tag-page__tree-label {\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    min-height: 32px;\n    padding: 4px 8px;\n    border-radius: 8px;\n    text-align: left;\n}\n\n.tag-page__tree-label span:first-child {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.tag-page__tree-type {\n    flex: 0 0 auto;\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n.tag-page__tree-toggle:hover,\n.tag-page__tree-toggle:focus-visible,\n.tag-page__tree-label:hover,\n.tag-page__tree-label:focus-visible,\n.tag-page__tree-label.is-selected {\n    background: var(--hmi-hover);\n    outline: none;\n}\n\n.tag-page__tree-label.is-selected,\n.tag-page__table tbody tr.is-selected td {\n    background: var(--hmi-hover);\n    color: var(--hmi-accent);\n}\n\n.tag-page__tree-label:focus-visible,\n.tag-page__tree-toggle:focus-visible,\n.tag-page__row-select:focus-visible {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.tag-page__details {\n    padding: 0 14px 14px;\n}\n\n.tag-page__facts {\n    display: grid;\n    gap: 10px;\n    margin: 12px 0;\n}\n\n.tag-page__facts div {\n    display: grid;\n    gap: 2px;\n}\n\n.tag-page__facts dt {\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.tag-page__facts dd {\n    margin: 0;\n    color: var(--hmi-text);\n    font-size: 14px;\n    overflow-wrap: anywhere;\n}\n\n.tag-page__register {\n    display: grid;\n    gap: 12px;\n    padding-top: 12px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.tag-page__register p {\n    color: var(--hmi-muted);\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n.tag-page__register h4 {\n    font-size: 15px;\n}\n\n.tag-page__field input[readonly] {\n    background: var(--hmi-row);\n    color: var(--hmi-muted);\n}\n\n.tag-page__details .tag-page__empty {\n    padding: 24px 0;\n}\n\n.tag-page__row-select {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-weight: 600;\n    text-align: left;\n    cursor: pointer;\n}\n\n.tag-page__row-select:hover,\n.tag-page__row-select:focus-visible {\n    color: var(--hmi-accent);\n}\n\n.tag-page__top > .tag-page__button {\n    display: inline-flex;\n    align-items: center;\n    flex: 0 0 auto;\n}\n\n.tag-page__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 10px;\n    margin: 16px 18px 0;\n}\n\n.tag-page__toolbar .tag-page__field {\n    min-width: 180px;\n    flex: 1 1 180px;\n}\n\n.tag-page__field--search {\n    flex: 1.4 1 240px;\n}\n\n.tag-page__copy-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.tag-page__copy-row input {\n    flex: 1;\n    min-width: 0;\n}\n\n.tag-page__register .tag-page__banner {\n    margin: 0;\n}\n\n.tag-page__workspace {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 10px var(--tag-panel-width, 380px);\n    align-items: start;\n    gap: 0;\n}\n\n.tag-page__workspace.is-collapsed {\n    grid-template-columns: minmax(0, 1fr);\n}\n\n.tag-page__tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.tag-page__tabs button {\n    min-height: 44px;\n    padding: 10px 18px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 12px;\n    background: var(--hmi-card);\n    color: var(--hmi-text);\n    font: inherit;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.tag-page__tabs button[aria-selected=\"true\"] {\n    border-color: var(--hmi-accent);\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.tag-page__registry-tools {\n    display: grid;\n    grid-template-columns: minmax(0, 1.4fr) minmax(180px, 0.6fr);\n    gap: 14px;\n    margin: 16px 18px;\n}\n\n.tag-page__registry-tools .tag-page__field {\n    min-width: 0;\n    margin: 0;\n}\n\n.tag-page__registry-scroll {\n    width: 100%;\n    margin: 0;\n}\n\n.tag-page__registry-table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n}\n\n.tag-page__registry-table th,\n.tag-page__registry-table td {\n    padding: 12px 14px;\n    border-bottom: 1px solid var(--hmi-border);\n    color: var(--hmi-text);\n    text-align: left;\n    vertical-align: middle;\n    overflow-wrap: anywhere;\n    font-size: 14px;\n}\n\n.tag-page__registry-table th {\n    background: var(--hmi-row);\n    color: var(--hmi-muted);\n    font-size: 11px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.tag-page__registry-table tbody tr.is-selected td {\n    background: var(--hmi-hover);\n}\n\n.tag-page__manage {\n    scroll-margin-top: 80px;\n}\n\n.tag-page__sr {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n.tag-page__divider {\n    align-self: stretch;\n    width: 10px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    cursor: col-resize;\n    touch-action: none;\n}\n\n.tag-page__divider::before {\n    content: \"\";\n    display: block;\n    width: 2px;\n    height: 100%;\n    min-height: 240px;\n    margin: 0 auto;\n    border-radius: 2px;\n    background: var(--hmi-border);\n}\n\n.tag-page__divider:focus-visible {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.tag-page__panel {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    min-height: 420px;\n    max-height: calc(100vh - 96px);\n    position: sticky;\n    top: 76px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 18px;\n    background: var(--hmi-card);\n    color: var(--hmi-text);\n    box-shadow: var(--hmi-shadow);\n    overflow: hidden;\n}\n\n.tag-page__panel[hidden] {\n    display: none;\n}\n\n.tag-page__panel-head {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 16px;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.tag-page__panel-actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.tag-page__panel-head h2 {\n    font-size: 18px;\n    letter-spacing: -0.02em;\n}\n\n.tag-page__panel-head p {\n    margin-top: 4px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.tag-page__panel-tools {\n    display: grid;\n    gap: 10px;\n    padding: 16px;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.tag-page__panel-tools .tag-page__field {\n    min-width: 0;\n    margin: 0;\n}\n\n.tag-page__panel .tag-page__banner {\n    margin: 12px 16px 0;\n}\n\n.tag-page__panel-body {\n    flex: 1;\n    min-height: 120px;\n    overflow: auto;\n}\n\n.tag-page__tag-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.tag-page__tag-item {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 8px;\n    align-items: center;\n    padding: 8px 12px 8px 0;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.tag-page__tag-item.is-selected {\n    background: var(--hmi-hover);\n}\n\n.tag-page__tag-edit {\n    min-height: 32px;\n    padding: 6px 10px;\n}\n\n.tag-page__tag-row {\n    display: grid;\n    gap: 4px;\n    width: 100%;\n    min-width: 0;\n    padding: 10px 16px;\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-size: 13px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.tag-page__tag-row:hover,\n.tag-page__tag-row:focus-visible {\n    background: var(--hmi-hover);\n}\n\n.tag-page__tag-item.is-selected .tag-page__strong {\n    color: var(--hmi-accent);\n}\n\n.tag-page__tag-row .tag-page__mono {\n    overflow-wrap: anywhere;\n}\n\n.tag-page__tag-server {\n    display: flex;\n    gap: 8px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.tag-page__manage {\n    min-width: 0;\n    max-width: 100%;\n}\n\n.tag-page__manage-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 18px 18px 14px;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.tag-page__manage-head h2 {\n    font-size: 18px;\n    letter-spacing: -0.02em;\n}\n\n.tag-page__manage-head p {\n    margin-top: 4px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.tag-page__editor-close {\n    display: inline-grid;\n    place-items: center;\n    width: 40px;\n    height: 40px;\n    flex: 0 0 auto;\n    padding: 0;\n    border: 1px solid var(--hmi-border);\n    border-radius: 12px;\n    background: var(--hmi-card);\n    color: var(--hmi-text);\n    font-size: 24px;\n    line-height: 1;\n    cursor: pointer;\n}\n\n.tag-page__editor-close:hover,\n.tag-page__editor-close:focus-visible {\n    border-color: var(--hmi-accent);\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.tag-page__identity {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 12px 18px;\n    margin: 0;\n    padding: 16px 18px;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.tag-page__identity dt {\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.tag-page__identity dd {\n    margin: 4px 0 0;\n    overflow-wrap: anywhere;\n}\n\n.tag-page__editor-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px;\n    margin: 16px 18px;\n}\n\n.tag-page__editor textarea {\n    width: 100%;\n    min-height: 72px;\n    padding: 8px 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n}\n\n.tag-page__editor-span {\n    grid-column: 1 / -1;\n}\n\n.tag-page__group {\n    display: grid;\n    align-content: start;\n    gap: 12px;\n    min-width: 0;\n    padding: 14px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 14px;\n    background: var(--hmi-row);\n}\n\n.tag-page__group h3 {\n    margin: 0;\n    font-size: 15px;\n}\n\n.tag-page__group .tag-page__actions {\n    align-items: flex-end;\n}\n\n.tag-page__group .tag-page__actions .tag-page__field {\n    flex: 1 1 180px;\n}\n\n.tag-page__manage .tag-page__field,\n.tag-page__manage .tag-page__hint,\n.tag-page__manage .tag-page__banner,\n.tag-page__manage .tag-page__actions {\n    min-width: 0;\n    margin: 0;\n}\n\n.tag-page__manage .tag-page__editor-actions,\n.tag-page__manage .tag-page__banner,\n.tag-page__editor > .tag-page__hint,\n.tag-page__manage > .tag-page__hint {\n    margin: 0 18px 12px;\n}\n\n.tag-page__editor-actions {\n    padding-bottom: 6px;\n}\n\n.tag-page__status {\n    display: inline-flex;\n    width: fit-content;\n    align-items: center;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n}\n\n.tag-page__status--ONLINE {\n    color: var(--hmi-good);\n    background: var(--hmi-good-bg);\n}\n\n.tag-page__status--OFFLINE {\n    color: var(--hmi-danger);\n    background: var(--hmi-danger-bg);\n}\n\n.tag-page__status--UNKNOWN {\n    color: var(--hmi-warn);\n    background: var(--hmi-warn-bg);\n}\n\n.tag-page__archived {\n    display: grid;\n    gap: 12px;\n    margin: 0 18px 18px;\n    padding-top: 14px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.tag-page__archived-head,\n.tag-page__archived-list li {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n.tag-page__archived h3,\n.tag-page__archived-list {\n    margin: 0;\n}\n\n.tag-page__archived-list {\n    display: grid;\n    gap: 8px;\n    padding: 0;\n    list-style: none;\n}\n\n.tag-page__stored {\n    display: grid;\n    gap: 10px;\n    padding: 14px 16px 16px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.tag-page__stored h3 {\n    margin: 0;\n    font-size: 15px;\n}\n\n.tag-page__stored .tag-page__empty,\n.tag-page__stored .tag-page__hint,\n.tag-page__stored .tag-page__actions {\n    margin: 0;\n}\n\n.tag-page__stored .tag-page__empty {\n    padding: 0;\n}\n\n.tag-page__stored .tag-page__button:disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n}\n\n@media (max-width: 980px) {\n    .tag-page__form,\n    .tag-page__group-management-form,\n    .tag-page__card-head--split {\n        grid-template-columns: 1fr;\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .tag-page__tools {\n        justify-content: flex-start;\n    }\n\n    .tag-page__browser,\n    .tag-page__editor-grid,\n    .tag-page__identity {\n        grid-template-columns: 1fr;\n    }\n\n    .tag-page__editor-span {\n        grid-column: auto;\n    }\n\n    .tag-page__group-description,\n    .tag-page__group-actions {\n        grid-column: auto;\n        grid-row: auto;\n    }\n\n    .tag-page__group-tags-head {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .tag-page__group-tag-filters {\n        grid-template-columns: 1fr;\n        width: 100%;\n    }\n\n    .tag-page__group-tag-list {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 800px) {\n    .tag-page__workspace,\n    .tag-page__workspace.is-collapsed {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .tag-page__tabs {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 8px;\n        margin-bottom: 12px;\n    }\n\n    .tag-page__tabs button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        min-height: 40px;\n        padding: 8px 12px;\n        border: 1px solid var(--hmi-border);\n        border-radius: 12px;\n        background: var(--hmi-card);\n        color: var(--hmi-text);\n        font: inherit;\n        font-weight: 650;\n        cursor: pointer;\n    }\n\n    .tag-page__tabs button[aria-selected=\"true\"] {\n        border-color: var(--hmi-accent);\n        background: var(--hmi-accent);\n        color: var(--hmi-accent-ink);\n    }\n\n    .tag-page__divider {\n        display: none;\n    }\n\n    .tag-page__panel {\n        position: static;\n        max-height: none;\n        min-height: 0;\n    }\n\n    .tag-page__panel-body {\n        max-height: 50vh;\n    }\n\n    .tag-page {\n        padding: 18px 14px 28px;\n    }\n\n    .tag-page h1 {\n        font-size: 26px;\n    }\n\n    .tag-page__top,\n    .tag-page__copy-row {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .tag-page__actions .tag-page__button,\n    .tag-page__register > .tag-page__button {\n        width: 100%;\n    }\n\n    .tag-page__registry-tools,\n    .tag-page__editor-grid,\n    .tag-page__identity {\n        grid-template-columns: 1fr;\n    }\n\n    .tag-page__registry-table thead {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        overflow: hidden;\n        clip: rect(0, 0, 0, 0);\n    }\n\n    .tag-page__registry-table,\n    .tag-page__registry-table tbody,\n    .tag-page__registry-table tr,\n    .tag-page__registry-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .tag-page__registry-table tr {\n        padding: 8px 0 12px;\n        border-bottom: 1px solid var(--hmi-border);\n    }\n\n    .tag-page__registry-table td {\n        border-bottom: 0;\n        padding: 6px 16px;\n    }\n\n    .tag-page__registry-table td::before {\n        content: attr(data-label);\n        display: block;\n        margin-bottom: 2px;\n        color: var(--hmi-muted);\n        font-size: 11px;\n        font-weight: 500;\n        letter-spacing: 0.05em;\n        text-transform: uppercase;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .tag-page__button,\n    .tag-page__table td {\n        transition: none;\n    }\n}\n\n.tag-page__metadata section + section {\n    margin-top: 16px;\n    padding-top: 14px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.tag-page__metadata h4,\n.tag-page__suggestion h4 {\n    margin: 0 0 6px;\n    color: var(--hmi-text);\n    font-size: 13px;\n}\n\n.tag-page__meta-source,\n.tag-page__metadata p,\n.tag-page__suggestion p {\n    margin: 0 0 8px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.tag-page__metadata .tag-page__facts dd,\n.tag-page__suggestion .tag-page__facts dd {\n    font-family: \"Geist Mono\", ui-monospace, monospace;\n    overflow-wrap: anywhere;\n}\n\n.tag-page__quality.is-good {\n    color: var(--hmi-good);\n}\n\n.tag-page__quality.is-bad {\n    color: var(--hmi-danger);\n}\n\n.tag-page__quality.is-uncertain {\n    color: var(--hmi-warn);\n}\n\n.tag-page__suggestion {\n    margin-top: 16px;\n    padding: 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 12px;\n    background: var(--hmi-row);\n}\n\n.tag-page__suggestion ul {\n    margin: 8px 0 0;\n    padding-left: 18px;\n    color: var(--hmi-text);\n}\n\n.tag-page__review {\n    display: grid;\n    gap: 10px;\n    margin: 16px 0;\n    padding: 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 12px;\n    background: var(--hmi-row);\n}\n\n.tag-page__review legend {\n    padding: 0 4px;\n    color: var(--hmi-text);\n    font-weight: 500;\n}\n\n.tag-page__check {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    color: var(--hmi-text);\n}\n\n.tag-page__section {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px 16px;\n    margin: 0;\n    padding: 4px 0 8px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.tag-page__section h3 {\n    margin: 0;\n    color: var(--hmi-muted);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.tag-page__create {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px 16px;\n    margin: 16px 18px;\n}\n\n.tag-page__create--embedded {\n    margin: 12px 0 0;\n    padding-top: 12px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.tag-page__create .tag-page__field--wide,\n.tag-page__create .tag-page__actions,\n.tag-page__create .tag-page__hint,\n.tag-page__create .tag-page__banner {\n    grid-column: 1 / -1;\n    margin: 0;\n}\n\n.tag-page__create textarea {\n    width: 100%;\n    min-height: 72px;\n    padding: 8px 10px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 8px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n}\n\n.tag-page__required {\n    color: var(--hmi-danger);\n    font-size: 12px;\n}\n\n.tag-page__field-error {\n    margin: 4px 0 0;\n    color: var(--hmi-danger);\n    font-size: 12px;\n}\n\n@media (min-width: 760px) {\n    .tag-page__create {\n        grid-template-columns: 1fr;\n    }\n\n    .tag-page__section {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .tag-page__section h3,\n    .tag-page__section .tag-page__field--wide,\n    .tag-page__section .tag-page__hint,\n    .tag-page__section .tag-page__banner {\n        grid-column: 1 / -1;\n    }\n}\n\n.tag-page__check {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n}\n\n.tag-page__lifecycle {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 999px;\n    color: var(--hmi-muted);\n    font-size: 12px;\n    letter-spacing: 0.04em;\n}\n\n.tag-page__lifecycle--ACTIVE {\n    color: var(--hmi-text);\n    border-color: var(--hmi-text);\n}\n\n.tag-page__occupants {\n    margin: 0;\n    padding-left: 18px;\n    color: var(--hmi-muted);\n}\n\n.tag-page__dialog {\n    margin-top: 16px;\n    padding: 16px;\n    border: 1px solid var(--hmi-danger);\n    border-radius: 12px;\n    background: var(--hmi-card);\n}\n\n.tag-page__dialog h3 {\n    margin: 0 0 8px;\n    font-weight: 500;\n}\n\n.tag-page__archived-page {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    margin: 0 18px 18px;\n}\n\n.tag-page__archived-detail {\n    width: 100%;\n    margin: 0;\n}\n\n.tag-page__archived-detail .tag-page__identity {\n    margin: 0 18px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
